import React from "react";
export default function AboutPage() {
  return (
    <div style={{ padding: "2rem" }}>
      {" "}
      <h2>About</h2> <p>This is a placeholder About page for Sai Sruti.</p>{" "}
    </div>
  );
}
